import React from 'react';
import { connect } from 'react-redux'
import {
  reports_index,
  archive_report,
  reset_report_errors
 } from '../actions'
import { Link, Redirect } from 'react-router-dom'
import Pagination from './Pagination'
import Loading from './Loading';
import {
  is_logged_on,
  is_validating
 } from "../helpers"

const mapStateToProps = state => {
  return {
    report: state.report
  };
};

const mapDispatchToProps = dispatch => {
    return {
      getReports: (page) => dispatch ( reports_index(page) ),
      archiveReport: (report_id, page) => dispatch ( archive_report(report_id, page) ),
      resetErrors: () => dispatch ( reset_report_errors() )
    }
}

class ConnectedProjects extends React.Component {
  constructor () {
    super()
    this.state = {
      clickedId: ''
    }
  }

  setCurrent(id) {
    this.setState({clickedId: id})
  }

  resetCurrent() {
    this.setState({clickedId: ''})
  }

  archiveReport(report_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.report.pagination
    this.props.archiveReport(report_id, page)
  }

  componentDidMount() {
    this.props.getReports(1)
  }

  componentWillUnmount() {
    this.props.resetErrors()
  }

  render() {
    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/" />
    }

    const { fetching } = this.props.report;

    if (fetching || typeof(this.props.report.pagination) === "undefined") {
      return (
       <Loading />
      )
    }

    const reports = this.props.report.items;

    const pagination = (typeof(this.props.report.pagination) === "undefined") ? {page: 1, per_page:10} : this.props.report.pagination;

    return (
      <div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Projects List</span>
					<i className="material-icons right">list</i>
				</div>
				<table className="bordered striped highlight responsive-table projects-list">
					<thead>
						<tr>
							<th>Project Name</th>
							<th>Date Created</th>
              {
                // <th>User</th>
              }
							<th>Details</th>
							<th>Status</th>
						</tr>
					</thead>
				 	<tbody>
						{reports.map(function(report){
							const { id, name, created_at, optimizations, archived, rows, file_name } = report;
              const current = this.state.clickedId

              let links
              if (report.id !== current) {
                links = (
                  <div className="meta" onMouseLeave={(e) => {
                    this.resetCurrent()
                  }}>
                    <Link className="c-darkgrey" to={`/projects/${report.id}`}>View</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.setCurrent(report.id)
                      }}
                      > Trash</Link>
                  </div>
                )
              } else {
                links = (
                  <div className="meta">
                    <Link className="c-darkgrey" to="#" onClick={(e)=>{
                      e.preventDefault()
                      this.resetCurrent()
                    }}>Cancel</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.archiveReport(report.id)
                      }}
                      >Are you sure?</Link>
                  </div>
                )
              }

              let statusIcon, statusTitle

              if ( optimizations > 0 ) {
                statusIcon = <i className="material-icons c-light-green">cloud_done</i>
                statusTitle = "Optimized instances exist "
              } else {
                statusIcon = <i className="material-icons c-grey">cloud_off</i>
                statusTitle = "There are no optimized instances"
              }


							return (
								<tr key={id}>
									<td>
										<Link className="view" to={`/projects/${report.id}`}>{name}</Link>
                    <p className="reportUrl c-darkgrey">
                      { file_name ? `Original File: ${file_name}` : 'Uploaded from file' }
                    </p>
                    { links }
									</td>
									<td>{new Date(created_at).toLocaleDateString()}, {new Date(created_at).toLocaleTimeString()}</td>
                  {
                    // <td>user here</td>
                  }
									<td>
                    <small><p>{rows} Rows on original report</p></small>
										<small><p>{optimizations} Optimized reports</p></small>
                    <small><p>{archived} Archived</p></small>
									</td>
									<td title={statusTitle}>
                    { statusIcon }
									</td>
								</tr>
							)
						}, this)}
			 		</tbody>
				</table>
        <Pagination pagination={pagination} fetchPage={this.props.getReports}/>
      </div>
    )
  }

}

const Projects = connect(mapStateToProps, mapDispatchToProps)(ConnectedProjects);

export default Projects;



// WEBPACK FOOTER //
// ./src/js/components/Projects.js